import React, { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import * as walletService from '../../services/walletService'
import { getAffiliateCommissionHistory } from '../../services/affiliateService'
import type { AffiliateOutletContext } from './ModernAffiliateLayout'
import type { AffiliateCommissionHistoryItem } from '../../services/affiliateService'
import {
  formatCommissionHistoryDateTime,
  formatCommissionMemberLabel,
} from '../../utils/affiliateHistoryUtils'

function maskMember(raw: string): string {
  const s = String(raw || '').trim()
  if (!s) return 'สมาชิก'
  if (s.length < 4) return s
  if (/^\d+$/.test(s)) {
    if (s.length >= 10) return s.slice(0, 3) + 'xxxxxx' + s.slice(-1)
    return s.slice(0, 2) + 'xxxxx' + s.slice(-1)
  }
  if (s.length <= 6) return s.slice(0, 1) + 'xxx' + s.slice(-1)
  return s.slice(0, 2) + '****' + s.slice(-3)
}

const AffiliateIncomePage: React.FC = () => {
  useOutletContext<AffiliateOutletContext>()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [commissionHistory, setCommissionHistory] = useState<AffiliateCommissionHistoryItem[]>([])

  useEffect(() => {
    let cancelled = false
    async function load() {
      setLoading(true)
      setError(null)
      try {
        const history = await getAffiliateCommissionHistory(100)
        if (!cancelled) {
          setCommissionHistory(history)
        }
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : 'โหลดข้อมูลไม่สำเร็จ')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [])

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border text-primary" role="status" />
        <p className="mt-2 c_tertiary">กำลังโหลดข้อมูล...</p>
      </div>
    )
  }
  if (error) {
    return (
      <div className="text-center py-4">
        <p className="c_primary mb-0">{error}</p>
      </div>
    )
  }

  return (
    <div className="row mx__1">
      {commissionHistory.length > 0 ? (
        <div className="col-12 px-1 mb-3">
          <div className="border_5 bdc_primary bg_op_secondary p-2 overflow-hidden">
            <small className="c_tertiary font_md">ประวัติคอมมิชชั่น</small>
            <div className="table-responsive w-100 mt-1">
              <table className="table bg_secondary table-striped table-huay-result text-center border_5 mb-0">
                <thead className="bg_gd_primary">
                  <tr>
                    <th scope="col" className="c_tertiary bg-transparent">วันที่ เวลา</th>
                    <th scope="col" className="c_tertiary bg-transparent">สมาชิก</th>
                    <th scope="col" className="c_tertiary bg-transparent">ยอดเสีย/ยอดแทง</th>
                    <th scope="col" className="c_tertiary bg-transparent">คอมมิชชั่น</th>
                  </tr>
                </thead>
                <tbody>
                  {commissionHistory.map((item, i) => (
                    <tr key={item._id || `${item.createdAt || item.date}-${i}`}>
                      <td>{formatCommissionHistoryDateTime(item)}</td>
                      <td>{formatCommissionMemberLabel(item, maskMember)}</td>
                      <td>{walletService.formatCurrency(item.betAmount ?? 0)}</td>
                      <td>{walletService.formatCurrency(item.commission ?? 0)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-12 px-1">
          <div className="border_5 bg_secondary py-5 overflow-hidden">
            <h4 className="text-center c_primary mb-0">ไม่มีประวัติคอมมิชชั่น</h4>
          </div>
        </div>
      )}
    </div>
  )
}

export default AffiliateIncomePage
